const TRAINER_PORTAL_HOSTNAME = 'trainer.dohockey.app';

export const isTrainerPortalHostname = (hostname: string): boolean =>
  hostname.trim().toLowerCase() === TRAINER_PORTAL_HOSTNAME;
